/* @ngInject */
function CostFactory($http, TrackingStateService, $rootScope) {
  class Cost {
    constructor(data) {
      if (data) angular.extend(this, data);
    }

    static getResourceUrl() {
      return `${process.env.SERVER_URL}/api/secure/organization/${$rootScope.organization.slug}/costs`;
    }

    isNew() {
      return !this._id;
    }

    setDataFromCostSnapshot(costSnapshotData) {
      this.name = costSnapshotData.name;
      this.unit = costSnapshotData.unit;
      this.price = costSnapshotData.price;
      this.currency = costSnapshotData.currency;
      this.amount = costSnapshotData.amount;
      this.comments = costSnapshotData.comments;
    }

    static query(params) {
      return $http
        .get(Cost.getResourceUrl(), { params })
        .then((response) =>
          response.data.map((costData) => new Cost(costData))
        );
    }

    static getCount(params) {
      return $http
        .get(`${Cost.getResourceUrl()}/count`, { params })
        .then((response) => response.data);
    }

    static exportCsv() {
      return $http
        .get(`${Cost.getResourceUrl()}/export/csv`)
        .then((response) => response.data);
    }

    static importCsv(fromDataFile) {
      return $http
        .post(`${Cost.getResourceUrl()}/import/csv`, fromDataFile, {
          headers: { "Content-Type": undefined },
        })
        .then((response) => response.data);
    }

    save() {
      return this.isNew() ? this.create() : this.update();
    }

    create() {
      if (!this.isNew()) throw new Error("The cost is already created");

      TrackingStateService.trackCustomEvent("new-cost");
      return $http
        .post(Cost.getResourceUrl(), this)
        .then((response) => angular.extend(this, response.data));
    }

    update() {
      if (this.isNew())
        throw new Error("Can not update a cost that has not been created");

      return $http
        .put(`${Cost.getResourceUrl()}/${this._id}`, this)
        .then((response) => angular.extend(this, response.data));
    }

    delete() {
      if (this.isNew())
        throw new Error("Can not delete a cost that has not been created");

      return $http
        .delete(`${Cost.getResourceUrl()}/${this._id}`)
        .then(() => true);
    }
  }

  return Cost;
}

export default CostFactory;
